/**
 * Created by Oles on 4/27/2017.
 */
export const PatientActions = {
    GET_TEST_RESULTS: 'GET_TEST_RESULTS',
    SET_TEST_RESULTS: 'SET_TEST_RESULTS',
    SHOW_TEST_DETAILS: 'SHOW_TEST_DETAILS',
    SAVE_TEST_DETAILS: 'SAVE_TEST_DETAILS',
    SHOW_MESSAGE_BOX: 'SHOW_MESSAGE_BOX',
    SET_CURRENT_TEST: 'SET_CURRENT_TEST',
    SET_LABS: 'SET_LABS',
    SET_GENES: 'SET_GENES',
    SET_TEST_DETAILS_SAVING: 'SET_TEST_DETAILS_SAVING',
    SET_AMBRY_STATUS: 'SET_AMBRY_STATUS',
    SET_COLUMNS_WIDTH: 'SET_COLUMNS_WIDTH',
};

export const TestActions = {
    EDIT_TEST: 'EDIT_TEST',
    REMOVE_TEST: 'REMOVE_TEST',
    ADD_GENES_TABLE_ROW: 'ADD_GENES_TABLE_ROW',
    UPDATE_TEST_DETAILS: 'UPDATE_TEST_DETAILS',
    SELECT_GENE: 'SELECT_GENE',
    SELECT_ALL_GENES: 'SELECT_ALL_GENES',
    DELETE_GENES_TABLE_ROW: 'DELETE_GENES_TABLE_ROW',
    UPDATE_GENES_TABLE_ROW: 'UPDATE_GENES_TABLE_ROW',
    SELECT_LAB: 'SELECT_LAB',
    SELECT_TEST_ORDERED: 'SELECT_TEST_ORDERED',
    SELECT_TEST_STATUS: 'SELECT_TEST_STATUS',
    SET_VALIDATION_RESULT: 'SET_VALIDATION_RESULT',
    UPLOAD_DOCS: 'UPLOAD_DOCS',
    UNLOAD_DOC: 'UNLOAD_DOC',
    SET_CURRENT_DOC: 'SET_CURRENT_DOC',
    GET_DOC: 'GET_DOC',
    DELETE_DOC: 'DELETE_DOC',
    SET_DOC_TO_DELETE: 'SET_DOC_TO_DELETE',
    RESET_MULTIPLE_REPORTS_FLAG: 'RESET_MULTIPLE_REPORTS_FLAG',
    SET_BLACKLIST_FILE_EXTENSIONS: 'SET_BLACKLIST_FILE_EXTENSIONS',
};

export const ResultsTableActions = {
    SET_DEFAULT_WIDTH: 'SET_DEFAULT_WIDTH',
    RESIZE_COLUMN: 'RESIZE_COLUMN'
};